import { IconFont } from '@/components/IconFont'
import classnames from 'classnames'
import { memo, useMemo } from 'react'
import { Outlet, useMatch, useNavigate } from 'react-router-dom'
import styles from './index.module.less'

const menus = [
  { key: 'list', icon: 'icon-file' },
  { key: 'gantt', icon: 'icon-list1' }
]

const ProjectTask = memo(function () {
  const navigate = useNavigate()
  const match = useMatch('/main/projects/:projectId/task/:key/*')
  const activeKey = useMemo(() => match?.params.key || '', [match])

  return (
    <div className={styles.container}>
      <div className={styles.sider}>
        {menus.map((item) => (
          <div
            key={item.key}
            className={classnames(styles.siderItem, { [styles.active]: activeKey === item.key })}
            onClick={() => navigate(item.key)}
          >
            <IconFont type={item.icon} />
          </div>
        ))}
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  )
})

export default ProjectTask
